import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

export const mailTagRuleActionTypeSchema = z.enum(['create-todo']);
export type MailTagRuleActionType = z.infer<typeof mailTagRuleActionTypeSchema>;

export const createTodoRuleConfigSchema = z.object({
  listTitle: z.string().min(1).max(100),
  titleTemplate: z.string().min(1).max(200),
});
export type CreateTodoRuleConfig = z.infer<typeof createTodoRuleConfigSchema>;

export const mailTagRuleSchema = z.object({
  id: uuidSchema,
  ownerSub: z.string(),
  tagId: uuidSchema,
  actionType: mailTagRuleActionTypeSchema,
  config: createTodoRuleConfigSchema,
  createdAt: isoDateStringSchema,
});
export type MailTagRule = z.infer<typeof mailTagRuleSchema>;

export const createMailTagRuleSchema = z.object({
  tagId: uuidSchema,
  actionType: mailTagRuleActionTypeSchema,
  config: createTodoRuleConfigSchema,
});
export type CreateMailTagRule = z.infer<typeof createMailTagRuleSchema>;
